'use client';

import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { TopTenPage } from '@/app/(appHeader)/promotions/2025-pick-and-choo/top10/TopTenPage';
import { useInAppState } from '@/contexts/InAppProvider';

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');
  return <TopTenPage isApp={isApp} />;
}
